const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.334 16.533c-.738.722-2.668 2.667-2.668 4.267h-5.332c0-1.6-1.93-3.545-2.668-4.267-1.383-1.355-2.133-3.244-2.133-5.333a7.468 7.468 0 0114.933 0c0 2.09-.75 3.978-2.133 5.333zm-8 6.4h5.332v-1.066h-5.332zm0 2.134h5.332V24h-5.332zm5.332 2.133h-1.165a1.593 1.593 0 01-1.5 1.066 1.594 1.594 0 01-1.503-1.066h-1.164v-1.067h5.332zM16 0c8.837 0 16 7.163 16 16 0 8.836-7.163 16-16 16S0 24.836 0 16C0 7.163 7.164 0 16 0zm2.133 8.533c-.875 0-1.647.43-2.133 1.083a2.66 2.66 0 00-2.134-1.083A2.67 2.67 0 0011.2 11.2c0 1.382.917 2.201 1.654 2.86.543.484 1.012.903 1.012 1.407v1.6h1.067v-1.6c0-.982-.696-1.603-1.368-2.204-.668-.595-1.299-1.159-1.299-2.063 0-.882.718-1.6 1.6-1.6.883 0 1.6.718 1.6 1.6h1.067c0-.882.718-1.6 1.6-1.6s1.6.718 1.6 1.6c0 .904-.63 1.468-1.298 2.063-.673.601-1.368 1.222-1.368 2.204v1.6h1.066v-1.6c0-.504.47-.923 1.012-1.408.737-.658 1.655-1.477 1.655-2.859a2.67 2.67 0 00-2.667-2.667z"
});

const SvgUnderstand = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f4d065",
    fillRule: "evenodd",
    height: 32,
    width: 32,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnderstand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/understand.21dc93df.svg";
export { ForwardRef as ReactComponent };